"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const footer_1 = require("./footer/footer");
const react_router_dom_1 = require("react-router-dom");
exports.FooterWrapper = (0, react_1.memo)(() => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", minHeight: "100%", overflow: "auto", children: [(0, jsx_runtime_1.jsx)(material_1.Stack, { flex: 1, children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }), (0, jsx_runtime_1.jsx)(footer_1.Footer, {})] }));
});
exports.FooterWrapper.displayName = "FooterWrapper";
